<template>
  <div class="row">
    <div class="col-12">
      <div class="row row-cols-1 mt-5">
        <h1 class="mb-4">台灣虎航 W25(25冬季班表) 航班時間速查工具</h1>
        <div class="filter-form">
          <div class="row">
            <div class="col-md-3">
              <label for="tripType">行程類型</label>
              <select v-model="filters.tripType" class="form-select" id="tripType">
                <!-- <option value="">無限制</option> -->
                <option value="one-way" selected>單程</option>
                <!-- <option value="round-trip">來回</option>
                        <option value="multi-city">不同點</option> -->
              </select>
            </div>
            <div class="col-md-3">
              <label for="origin">出發地</label>
              <input v-model="filters.origin" type="text" class="form-control" id="origin" placeholder="輸入起點 (如 TPE)" />
            </div>
            <div class="col-md-3">
              <label for="destination">目的地</label>
              <input v-model="filters.destination" type="text" class="form-control" id="destination" placeholder="輸入終點 (如 NRT)" />
            </div>
            <div class="col-md-3">
              <label for="flightNumber">班次</label>
              <input v-model="filters.flightNumber" type="text" class="form-control" id="flightNumber" placeholder="輸入航班號 (如 IT200)" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label for="departureTimeRange">出發時間範圍</label>
              <select v-model="filters.departureTimeRange" class="form-select" id="departureTimeRange">
                <option value="">不限範圍</option>
                <option v-for="range in timeRanges" :key="range.value" :value="range.value">{{ range.label }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <label for="arrivalTimeRange">抵達時間範圍</label>
              <select v-model="filters.arrivalTimeRange" class="form-select" id="arrivalTimeRange">
                <option value="">不限範圍</option>
                <option v-for="range in timeRanges" :key="range.value" :value="range.value">{{ range.label }}</option>
              </select>
            </div>
            <div class="col-md-6">
              <div class="form-text" id="basic-addon0">。出發地、目的地以 IATA 代碼顯示，如桃園機場代碼為 TPE，日本新千歲機場為 CTS，以此類推</div>
              <div class="form-text" id="basic-addon1">。本工具僅作為旅程規劃過程參考，實際航班時間仍以官網或官網訂位系統顯示為準</div>
              <div class="form-text fs-4" id="basic-addon2"><a href="https://www.tigerairtw.com/zh-TW/ready-to-go/flight-schedule" target="_blank">官網時刻表</a></div>
            </div>
            <!-- <div class="col-md-3">
                    <label for="dateRangeStart">日期範圍 (開始)</label>
                    <input v-model="filters.dateRangeStart" type="date" class="form-control" id="dateRangeStart">
                </div>
                <div class="col-md-3">
                    <label for="dateRangeEnd">日期範圍 (結束)</label>
                    <input v-model="filters.dateRangeEnd" type="date" class="form-control" id="dateRangeEnd">
                </div> -->
          </div>
          <button @click="resetFilters" class="btn btn-secondary mt-3">清除</button>
        </div>
        <div v-if="filters.tripType === 'round-trip' && filteredSchedules.length > 0 && !hasValidReturnFlights" class="alert alert-warning">注意：部分無匹配的回程航班，請檢查日期範圍或數據。</div>
        <div class="table-responsive">
          <table class="table table-bordered table-hover">
            <thead class="table-light">
              <tr>
                <th>出發地</th>
                <th>目的地</th>
                <th>班次</th>
                <th>出發時間</th>
                <th>抵達時間</th>
                <!-- <th>飛行時長</th> -->
                <th>週一</th>
                <th>週二</th>
                <th>週三</th>
                <th>週四</th>
                <th>週五</th>
                <th>週六</th>
                <th>週日</th>
                <th>運行日期</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(schedule, index) in filteredSchedules" :key="index">
                <td>{{ schedule.origin || "-" }}</td>
                <td>{{ schedule.destination || "-" }}</td>
                <td>{{ schedule.carrierCode ? schedule.carrierCode + schedule.flightNumber : "-" }}</td>
                <td>{{ formatTime(schedule.departureTime) }}</td>
                <td>{{ formatTime(schedule.arrivalTime) }}</td>
                <!-- <td>{{ schedule.durationInMinutes ? schedule.durationInMinutes + ' 分鐘' : '-' }}</td> -->
                <td><span :class="getDayClass(schedule.daysOfWeek, 'monday')"></span></td>
                <td><span :class="getDayClass(schedule.daysOfWeek, 'tuesday')"></span></td>
                <td><span :class="getDayClass(schedule.daysOfWeek, 'wednesday')"></span></td>
                <td><span :class="getDayClass(schedule.daysOfWeek, 'thursday')"></span></td>
                <td><span :class="getDayClass(schedule.daysOfWeek, 'friday')"></span></td>
                <td><span :class="getDayClass(schedule.daysOfWeek, 'saturday')"></span></td>
                <td><span :class="getDayClass(schedule.daysOfWeek, 'sunday')"></span></td>
                <td>{{ schedule.operationDateSummary || "-" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="filteredSchedules.length === 0" class="alert alert-info">查無航班資訊</div>
      </div>
    </div>
  </div>
</template>
<style>
  .table th,
  .table td {
    text-align: center;
    vertical-align: middle;
  }

  .filter-form {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
  }

  .filter-form .form-control,
  .filter-form .form-select {
    margin-bottom: 10px;
  }

  .day-circle-true,
  .day-circle-false {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
  }

  .day-circle-true {
    background-color: #28a745;
  }

  /* 綠色圓圈 */
  .day-circle-false {
    background-color: #dc3545;
  }

  /* 紅色圓圈 */
  .alert-warning {
    margin-top: 10px;
  }
</style>
<script>
  // const flightData = {
  //   data: [
  //     {
  //       countryCode: "JP",
  //       stationSchedules: [
  //         {
  //           iataCode: "HKD",
  //           schedules: [
  //             {
  //               origin: "TPE",
  //               destination: "HKD",
  //               carrierCode: "IT",
  //               flightNumber: "238",
  //               departureTime: "06:00:00",
  //               arrivalTime: "10:40:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 220,
  //             },
  //             {
  //               origin: "HKD",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "239",
  //               departureTime: "11:40:00",
  //               arrivalTime: "15:30:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 290,
  //             },
  //           ],
  //         },
  //         {
  //           iataCode: "AKJ",
  //           schedules: [
  //             {
  //               origin: "TPE",
  //               destination: "AKJ",
  //               carrierCode: "IT",
  //               flightNumber: "732",
  //               departureTime: "12:00:00",
  //               arrivalTime: "16:50:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 230,
  //             },
  //             {
  //               origin: "AKJ",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "733",
  //               departureTime: "17:50:00",
  //               arrivalTime: "22:00:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 270,
  //             },
  //           ],
  //         },
  //         {
  //           iataCode: "NRT",
  //           schedules: [
  //             {
  //               origin: "TPE",
  //               destination: "NRT",
  //               carrierCode: "IT",
  //               flightNumber: "200",
  //               departureTime: "06:10:00",
  //               arrivalTime: "10:35:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: true,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 205,
  //             },
  //             {
  //               origin: "TPE",
  //               destination: "NRT",
  //               carrierCode: "IT",
  //               flightNumber: "200",
  //               departureTime: "06:35:00",
  //               arrivalTime: "10:35:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 180,
  //             },
  //             {
  //               origin: "TPE",
  //               destination: "NRT",
  //               carrierCode: "IT",
  //               flightNumber: "202",
  //               departureTime: "13:30:00",
  //               arrivalTime: "17:30:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: false,
  //                 wednesday: true,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 180,
  //             },
  //             {
  //               origin: "TPE",
  //               destination: "NRT",
  //               carrierCode: "IT",
  //               flightNumber: "202",
  //               departureTime: "15:35:00",
  //               arrivalTime: "19:35:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 180,
  //             },
  //             {
  //               origin: "NRT",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "201",
  //               departureTime: "11:25:00",
  //               arrivalTime: "14:45:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 260,
  //             },
  //             {
  //               origin: "NRT",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "201",
  //               departureTime: "12:00:00",
  //               arrivalTime: "15:25:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 265,
  //             },
  //             {
  //               origin: "NRT",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "201",
  //               departureTime: "13:00:00",
  //               arrivalTime: "16:25:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: false,
  //                 wednesday: true,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 265,
  //             },
  //             {
  //               origin: "NRT",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "203",
  //               departureTime: "18:25:00",
  //               arrivalTime: "21:50:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: false,
  //                 wednesday: true,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 265,
  //             },
  //             {
  //               origin: "NRT",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "203",
  //               departureTime: "18:25:00",
  //               arrivalTime: "21:55:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 270,
  //             },
  //             {
  //               origin: "NRT",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "203",
  //               departureTime: "18:30:00",
  //               arrivalTime: "21:50:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 260,
  //             },
  //             {
  //               origin: "NRT",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "203",
  //               departureTime: "20:25:00",
  //               arrivalTime: "23:30:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 245,
  //             },
  //             {
  //               origin: "NRT",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "203",
  //               departureTime: "20:25:00",
  //               arrivalTime: "23:25:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 240,
  //             },
  //             {
  //               origin: "KHH",
  //               destination: "NRT",
  //               carrierCode: "IT",
  //               flightNumber: "280",
  //               departureTime: "06:55:00",
  //               arrivalTime: "11:10:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 195,
  //             },
  //             {
  //               origin: "KHH",
  //               destination: "NRT",
  //               carrierCode: "IT",
  //               flightNumber: "280",
  //               departureTime: "08:00:00",
  //               arrivalTime: "12:10:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 190,
  //             },
  //             {
  //               origin: "NRT",
  //               destination: "KHH",
  //               carrierCode: "IT",
  //               flightNumber: "281",
  //               departureTime: "11:25:00",
  //               arrivalTime: "15:05:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: false,
  //                 wednesday: true,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 280,
  //             },
  //             {
  //               origin: "NRT",
  //               destination: "KHH",
  //               carrierCode: "IT",
  //               flightNumber: "281",
  //               departureTime: "13:00:00",
  //               arrivalTime: "16:40:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 280,
  //             },
  //           ],
  //         },
  //         {
  //           iataCode: "HND",
  //           schedules: [
  //             {
  //               origin: "TPE",
  //               destination: "HND",
  //               carrierCode: "IT",
  //               flightNumber: "216",
  //               departureTime: "00:10:00",
  //               arrivalTime: "04:00:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 170,
  //             },
  //             {
  //               origin: "HND",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "217",
  //               departureTime: "05:00:00",
  //               arrivalTime: "07:55:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 235,
  //             },
  //           ],
  //         },
  //         {
  //           iataCode: "FUK",
  //           schedules: [
  //             {
  //               origin: "TPE",
  //               destination: "FUK",
  //               carrierCode: "IT",
  //               flightNumber: "240",
  //               departureTime: "06:45:00",
  //               arrivalTime: "10:00:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 135,
  //             },
  //             {
  //               origin: "TPE",
  //               destination: "FUK",
  //               carrierCode: "IT",
  //               flightNumber: "720",
  //               departureTime: "13:40:00",
  //               arrivalTime: "16:55:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 135,
  //             },
  //             {
  //               origin: "FUK",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "241",
  //               departureTime: "10:55:00",
  //               arrivalTime: "12:40:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 165,
  //             },
  //             {
  //               origin: "FUK",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "721",
  //               departureTime: "17:55:00",
  //               arrivalTime: "19:35:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 160,
  //             },
  //             {
  //               origin: "FUK",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "721",
  //               departureTime: "17:55:00",
  //               arrivalTime: "19:40:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 165,
  //             },
  //             {
  //               origin: "KHH",
  //               destination: "FUK",
  //               carrierCode: "IT",
  //               flightNumber: "270",
  //               departureTime: "15:25:00",
  //               arrivalTime: "18:55:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 150,
  //             },
  //             {
  //               origin: "FUK",
  //               destination: "KHH",
  //               carrierCode: "IT",
  //               flightNumber: "271",
  //               departureTime: "19:55:00",
  //               arrivalTime: "21:55:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 180,
  //             },
  //           ],
  //         },
  //         {
  //           iataCode: "CTS",
  //           schedules: [
  //             {
  //               origin: "TPE",
  //               destination: "CTS",
  //               carrierCode: "IT",
  //               flightNumber: "234",
  //               departureTime: "06:15:00",
  //               arrivalTime: "10:55:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 220,
  //             },
  //             {
  //               origin: "TPE",
  //               destination: "CTS",
  //               carrierCode: "IT",
  //               flightNumber: "234",
  //               departureTime: "06:20:00",
  //               arrivalTime: "10:55:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: false,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 215,
  //             },
  //             {
  //               origin: "CTS",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "235",
  //               departureTime: "11:55:00",
  //               arrivalTime: "15:35:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 280,
  //             },
  //             {
  //               origin: "KHH",
  //               destination: "CTS",
  //               carrierCode: "IT",
  //               flightNumber: "260",
  //               departureTime: "07:45:00",
  //               arrivalTime: "12:55:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 250,
  //             },
  //             {
  //               origin: "CTS",
  //               destination: "KHH",
  //               carrierCode: "IT",
  //               flightNumber: "261",
  //               departureTime: "13:55:00",
  //               arrivalTime: "17:15:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 260,
  //             },
  //           ],
  //         },
  //         {
  //           iataCode: "KMI",
  //           schedules: [
  //             {
  //               origin: "TPE",
  //               destination: "KMI",
  //               carrierCode: "IT",
  //               flightNumber: "742",
  //               departureTime: "06:05:00",
  //               arrivalTime: "09:20:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 135,
  //             },
  //             {
  //               origin: "TPE",
  //               destination: "KMI",
  //               carrierCode: "IT",
  //               flightNumber: "742",
  //               departureTime: "06:10:00",
  //               arrivalTime: "09:20:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 130,
  //             },
  //             {
  //               origin: "KMI",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "743",
  //               departureTime: "10:30:00",
  //               arrivalTime: "12:00:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 150,
  //             },
  //           ],
  //         },
  //         {
  //           iataCode: "KIX",
  //           schedules: [
  //             {
  //               origin: "TPE",
  //               destination: "KIX",
  //               carrierCode: "IT",
  //               flightNumber: "210",
  //               departureTime: "06:55:00",
  //               arrivalTime: "10:25:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 150,
  //             },
  //             {
  //               origin: "TPE",
  //               destination: "KIX",
  //               carrierCode: "IT",
  //               flightNumber: "210",
  //               departureTime: "07:00:00",
  //               arrivalTime: "10:25:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: false,
  //                 wednesday: true,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 145,
  //             },
  //             {
  //               origin: "TPE",
  //               destination: "KIX",
  //               carrierCode: "IT",
  //               flightNumber: "212",
  //               departureTime: "14:40:00",
  //               arrivalTime: "17:55:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 135,
  //             },
  //             {
  //               origin: "KIX",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "211",
  //               departureTime: "11:30:00",
  //               arrivalTime: "13:50:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 200,
  //             },
  //             {
  //               origin: "KIX",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "213",
  //               departureTime: "18:55:00",
  //               arrivalTime: "21:20:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 205,
  //             },
  //             {
  //               origin: "KIX",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "213",
  //               departureTime: "18:55:00",
  //               arrivalTime: "21:15:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 200,
  //             },
  //             {
  //               origin: "KHH",
  //               destination: "KIX",
  //               carrierCode: "IT",
  //               flightNumber: "284",
  //               departureTime: "06:55:00",
  //               arrivalTime: "10:40:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 165,
  //             },
  //             {
  //               origin: "KIX",
  //               destination: "KHH",
  //               carrierCode: "IT",
  //               flightNumber: "285",
  //               departureTime: "11:30:00",
  //               arrivalTime: "14:00:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 210,
  //             },
  //             {
  //               origin: "KIX",
  //               destination: "KHH",
  //               carrierCode: "IT",
  //               flightNumber: "285",
  //               departureTime: "11:30:00",
  //               arrivalTime: "14:00:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/11/02-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 210,
  //             },
  //             {
  //               origin: "KIX",
  //               destination: "KHH",
  //               carrierCode: "IT",
  //               flightNumber: "285",
  //               departureTime: "12:00:00",
  //               arrivalTime: "14:30:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26",
  //               overnight: 0,
  //               durationInMinutes: 210,
  //             },
  //           ],
  //         },
  //         {
  //           iataCode: "OKA",
  //           schedules: [
  //             {
  //               origin: "TPE",
  //               destination: "OKA",
  //               carrierCode: "IT",
  //               flightNumber: "230",
  //               departureTime: "06:35:00",
  //               arrivalTime: "08:55:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 80,
  //             },
  //             {
  //               origin: "TPE",
  //               destination: "OKA",
  //               carrierCode: "IT",
  //               flightNumber: "232",
  //               departureTime: "18:20:00",
  //               arrivalTime: "20:40:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 80,
  //             },
  //             {
  //               origin: "OKA",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "231",
  //               departureTime: "09:45:00",
  //               arrivalTime: "10:20:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 95,
  //             },
  //             {
  //               origin: "OKA",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "233",
  //               departureTime: "21:30:00",
  //               arrivalTime: "21:55:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: true,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 85,
  //             },
  //             {
  //               origin: "OKA",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "233",
  //               departureTime: "21:30:00",
  //               arrivalTime: "22:05:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 95,
  //             },
  //           ],
  //         },
  //         {
  //           iataCode: "OKJ",
  //           schedules: [
  //             {
  //               origin: "TPE",
  //               destination: "OKJ",
  //               carrierCode: "IT",
  //               flightNumber: "214",
  //               departureTime: "11:10:00",
  //               arrivalTime: "14:35:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 145,
  //             },
  //             {
  //               origin: "TPE",
  //               destination: "OKJ",
  //               carrierCode: "IT",
  //               flightNumber: "714",
  //               departureTime: "13:05:00",
  //               arrivalTime: "16:30:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 145,
  //             },
  //             {
  //               origin: "OKJ",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "215",
  //               departureTime: "15:25:00",
  //               arrivalTime: "17:30:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 185,
  //             },
  //             {
  //               origin: "OKJ",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "715",
  //               departureTime: "17:55:00",
  //               arrivalTime: "19:55:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 180,
  //             },
  //             {
  //               origin: "OKJ",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "715",
  //               departureTime: "17:55:00",
  //               arrivalTime: "20:00:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 185,
  //             },
  //           ],
  //         },
  //         {
  //           iataCode: "KMQ",
  //           schedules: [
  //             {
  //               origin: "TPE",
  //               destination: "KMQ",
  //               carrierCode: "IT",
  //               flightNumber: "252",
  //               departureTime: "11:50:00",
  //               arrivalTime: "15:35:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 165,
  //             },
  //             {
  //               origin: "TPE",
  //               destination: "KMQ",
  //               carrierCode: "IT",
  //               flightNumber: "252",
  //               departureTime: "12:00:00",
  //               arrivalTime: "15:35:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 155,
  //             },
  //             {
  //               origin: "KMQ",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "253",
  //               departureTime: "16:45:00",
  //               arrivalTime: "19:30:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 225,
  //             },
  //             {
  //               origin: "KMQ",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "253",
  //               departureTime: "16:45:00",
  //               arrivalTime: "19:20:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 215,
  //             },
  //           ],
  //         },
  //         {
  //           iataCode: "HNA",
  //           schedules: [
  //             {
  //               origin: "TPE",
  //               destination: "HNA",
  //               carrierCode: "IT",
  //               flightNumber: "258",
  //               departureTime: "12:15:00",
  //               arrivalTime: "16:35:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: true,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 200,
  //             },
  //             {
  //               origin: "HNA",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "259",
  //               departureTime: "17:50:00",
  //               arrivalTime: "21:10:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 260,
  //             },
  //             {
  //               origin: "HNA",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "259",
  //               departureTime: "17:50:00",
  //               arrivalTime: "20:55:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: true,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 245,
  //             },
  //           ],
  //         },
  //         {
  //           iataCode: "KIJ",
  //           schedules: [
  //             {
  //               origin: "TPE",
  //               destination: "KIJ",
  //               carrierCode: "IT",
  //               flightNumber: "228",
  //               departureTime: "13:55:00",
  //               arrivalTime: "18:00:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 185,
  //             },
  //             {
  //               origin: "KIJ",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "229",
  //               departureTime: "19:00:00",
  //               arrivalTime: "22:30:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 270,
  //             },
  //           ],
  //         },
  //         {
  //           iataCode: "SDJ",
  //           schedules: [
  //             {
  //               origin: "TPE",
  //               destination: "SDJ",
  //               carrierCode: "IT",
  //               flightNumber: "254",
  //               departureTime: "14:35:00",
  //               arrivalTime: "18:45:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 190,
  //             },
  //             {
  //               origin: "SDJ",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "255",
  //               departureTime: "19:40:00",
  //               arrivalTime: "23:00:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 260,
  //             },
  //             {
  //               origin: "KHH",
  //               destination: "SDJ",
  //               carrierCode: "IT",
  //               flightNumber: "772",
  //               departureTime: "13:25:00",
  //               arrivalTime: "17:55:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: false,
  //                 wednesday: true,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 210,
  //             },
  //             {
  //               origin: "SDJ",
  //               destination: "KHH",
  //               carrierCode: "IT",
  //               flightNumber: "773",
  //               departureTime: "18:50:00",
  //               arrivalTime: "22:30:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: false,
  //                 wednesday: true,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 280,
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       countryCode: "KR",
  //       stationSchedules: [
  //         {
  //           iataCode: "CJU",
  //           schedules: [
  //             {
  //               origin: "TPE",
  //               destination: "CJU",
  //               carrierCode: "IT",
  //               flightNumber: "654",
  //               departureTime: "06:30:00",
  //               arrivalTime: "09:20:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: true,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 110,
  //             },
  //             {
  //               origin: "TPE",
  //               destination: "CJU",
  //               carrierCode: "IT",
  //               flightNumber: "654",
  //               departureTime: "07:05:00",
  //               arrivalTime: "10:00:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 115,
  //             },
  //             {
  //               origin: "TPE",
  //               destination: "CJU",
  //               carrierCode: "IT",
  //               flightNumber: "654",
  //               departureTime: "07:55:00",
  //               arrivalTime: "10:50:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 115,
  //             },
  //             {
  //               origin: "CJU",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "655",
  //               departureTime: "10:10:00",
  //               arrivalTime: "11:25:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: true,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 135,
  //             },
  //             {
  //               origin: "CJU",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "655",
  //               departureTime: "11:00:00",
  //               arrivalTime: "12:15:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 135,
  //             },
  //             {
  //               origin: "CJU",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "655",
  //               departureTime: "11:40:00",
  //               arrivalTime: "12:55:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 135,
  //             },
  //           ],
  //         },
  //         {
  //           iataCode: "GMP",
  //           schedules: [
  //             {
  //               origin: "KHH",
  //               destination: "GMP",
  //               carrierCode: "IT",
  //               flightNumber: "662",
  //               departureTime: "15:55:00",
  //               arrivalTime: "19:45:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 170,
  //             },
  //             {
  //               origin: "GMP",
  //               destination: "KHH",
  //               carrierCode: "IT",
  //               flightNumber: "663",
  //               departureTime: "20:35:00",
  //               arrivalTime: "22:40:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 185,
  //             },
  //             {
  //               origin: "GMP",
  //               destination: "KHH",
  //               carrierCode: "IT",
  //               flightNumber: "663",
  //               departureTime: "20:35:00",
  //               arrivalTime: "22:40:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 185,
  //             },
  //           ],
  //         },
  //         {
  //           iataCode: "PUS",
  //           schedules: [
  //             {
  //               origin: "TPE",
  //               destination: "PUS",
  //               carrierCode: "IT",
  //               flightNumber: "606",
  //               departureTime: "16:50:00",
  //               arrivalTime: "20:00:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 130,
  //             },
  //             {
  //               origin: "TPE",
  //               destination: "PUS",
  //               carrierCode: "IT",
  //               flightNumber: "606",
  //               departureTime: "16:50:00",
  //               arrivalTime: "20:05:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 135,
  //             },
  //             {
  //               origin: "TPE",
  //               destination: "PUS",
  //               carrierCode: "IT",
  //               flightNumber: "606",
  //               departureTime: "17:00:00",
  //               arrivalTime: "20:00:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 120,
  //             },
  //             {
  //               origin: "PUS",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "607",
  //               departureTime: "20:50:00",
  //               arrivalTime: "22:30:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: false,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 160,
  //             },
  //             {
  //               origin: "PUS",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "607",
  //               departureTime: "21:00:00",
  //               arrivalTime: "22:30:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 150,
  //             },
  //           ],
  //         },
  //         {
  //           iataCode: "ICN",
  //           schedules: [
  //             {
  //               origin: "TPE",
  //               destination: "ICN",
  //               carrierCode: "IT",
  //               flightNumber: "602",
  //               departureTime: "20:00:00",
  //               arrivalTime: "23:30:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 150,
  //             },
  //             {
  //               origin: "ICN",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "603",
  //               departureTime: "00:30:00",
  //               arrivalTime: "02:15:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 165,
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       countryCode: "VN",
  //       stationSchedules: [
  //         {
  //           iataCode: "DAD",
  //           schedules: [
  //             {
  //               origin: "KHH",
  //               destination: "DAD",
  //               carrierCode: "IT",
  //               flightNumber: "585",
  //               departureTime: "16:00:00",
  //               arrivalTime: "17:35:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 155,
  //             },
  //             {
  //               origin: "KHH",
  //               destination: "DAD",
  //               carrierCode: "IT",
  //               flightNumber: "585",
  //               departureTime: "17:35:00",
  //               arrivalTime: "19:10:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 155,
  //             },
  //             {
  //               origin: "DAD",
  //               destination: "KHH",
  //               carrierCode: "IT",
  //               flightNumber: "586",
  //               departureTime: "18:25:00",
  //               arrivalTime: "21:40:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: false,
  //                 wednesday: true,
  //                 thursday: true,
  //                 friday: false,
  //                 saturday: false,
  //                 sunday: true,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 135,
  //             },
  //             {
  //               origin: "DAD",
  //               destination: "KHH",
  //               carrierCode: "IT",
  //               flightNumber: "586",
  //               departureTime: "19:15:00",
  //               arrivalTime: "22:30:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 135,
  //             },
  //             {
  //               origin: "TPE",
  //               destination: "DAD",
  //               carrierCode: "IT",
  //               flightNumber: "551",
  //               departureTime: "16:50:00",
  //               arrivalTime: "18:25:00",
  //               daysOfWeek: {
  //                 monday: false,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: false,
  //                 friday: false,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 155,
  //             },
  //             {
  //               origin: "TPE",
  //               destination: "DAD",
  //               carrierCode: "IT",
  //               flightNumber: "551",
  //               departureTime: "17:25:00",
  //               arrivalTime: "19:10:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: false,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: false,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 165,
  //             },
  //             {
  //               origin: "DAD",
  //               destination: "TPE",
  //               carrierCode: "IT",
  //               flightNumber: "552",
  //               departureTime: "20:00:00",
  //               arrivalTime: "23:25:00",
  //               daysOfWeek: {
  //                 monday: true,
  //                 tuesday: true,
  //                 wednesday: false,
  //                 thursday: true,
  //                 friday: true,
  //                 saturday: true,
  //                 sunday: false,
  //               },
  //               operationDateSummary: "2025/10/26-2026/03/28",
  //               overnight: 0,
  //               durationInMinutes: 145,
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  // }
  import flightData from "../../public/ITW25FlightsSchedule.js"
  export default {
    data() {
      return {
        schedules: [],
        filters: {
          tripType: "one-way",
          origin: "TPE",
          destination: "",
          flightNumber: "",
          departureTimeRange: "",
          arrivalTimeRange: "",
          dateRangeStart: "",
          dateRangeEnd: "",
        },
        timeRanges: [
          { label: "00:00 ~ 03:00", value: "00:00-03:00" },
          { label: "03:00 ~ 06:00", value: "03:00-06:00" },
          { label: "06:00 ~ 09:00", value: "06:00-09:00" },
          { label: "09:00 ~ 12:00", value: "09:00-12:00" },
          { label: "12:00 ~ 15:00", value: "12:00-15:00" },
          { label: "15:00 ~ 18:00", value: "15:00-18:00" },
          { label: "18:00 ~ 21:00", value: "18:00-21:00" },
          { label: "21:00 ~ 00:00", value: "21:00-00:00" },
        ],
        hasValidReturnFlights: true,
      }
    },
    computed: {
      filteredSchedules() {
        return this.schedules
          .filter((schedule) => {
            const isValid = schedule && typeof schedule === "object" && schedule.origin && schedule.destination && schedule.carrierCode && schedule.flightNumber && schedule.departureTime && schedule.arrivalTime && schedule.operationDateSummary && schedule.daysOfWeek && typeof schedule.daysOfWeek === "object"
            if (!isValid) console.warn("Invalid schedule filtered out:", schedule)
            return isValid
          })
          .filter((schedule) => {
            const originMatch = this.filters.origin ? schedule.origin?.toLowerCase().includes(this.filters.origin.toLowerCase()) : true
            const destinationMatch = this.filters.destination ? schedule.destination?.toLowerCase().includes(this.filters.destination.toLowerCase()) : true
            const flightNumberMatch = this.filters.flightNumber ? (schedule.carrierCode + schedule.flightNumber).toLowerCase().includes(this.filters.flightNumber.toLowerCase()) : true
            const departureTimeMatch = this.filters.departureTimeRange ? this.isTimeInRange(schedule.departureTime, this.filters.departureTimeRange) : true
            const arrivalTimeMatch = this.filters.arrivalTimeRange ? this.isTimeInRange(schedule.arrivalTime, this.filters.arrivalTimeRange) : true
            const dateRangeMatch = this.filters.dateRangeStart || this.filters.dateRangeEnd ? this.isDateInRange(schedule.operationDateSummary, this.filters.dateRangeStart, this.filters.dateRangeEnd) : true
            const tripTypeMatch = this.isTripTypeMatch(schedule)
            return originMatch && destinationMatch && flightNumberMatch && departureTimeMatch && arrivalTimeMatch && dateRangeMatch && tripTypeMatch
          })
      },
    },
    methods: {
      resetFilters() {
        this.filters = {
          tripType: "",
          origin: "",
          destination: "",
          flightNumber: "",
          departureTimeRange: "",
          arrivalTimeRange: "",
          dateRangeStart: "",
          dateRangeEnd: "",
        }
        this.hasValidReturnFlights = true
      },
      isTimeInRange(time, range) {
        if (!time || !range) return false
        const [start, end] = range.split("-")
        const timeHour = parseInt(time.split(":")[0], 10)
        const startHour = parseInt(start.split(":")[0], 10)
        const endHour = parseInt(end.split(":")[0], 10)
        if (range === "21:00-00:00") {
          return timeHour >= 21 || timeHour <= 0
        }
        return timeHour >= startHour && timeHour <= endHour
      },
      isDateInRange(operationDateSummary, startDate, endDate) {
        if (!operationDateSummary) return false
        const [flightStart, flightEnd] = operationDateSummary.split("-").map((date) => new Date(date))
        const userStart = startDate ? new Date(startDate) : new Date("1970-01-01")
        const userEnd = endDate ? new Date(endDate) : new Date("9999-12-31")
        return flightStart <= userEnd && flightEnd >= userStart
      },
      isTripTypeMatch(schedule) {
        if (!this.filters.tripType || this.filters.tripType === "one-way" || this.filters.tripType === "multi-city") {
          return true // 無限制、單程或不同點直接通過
        }
        if (this.filters.tripType === "round-trip") {
          if (!this.filters.origin || !this.filters.destination) {
            console.warn("Round-trip requires both origin and destination")
            this.hasValidReturnFlights = false
            return false
          }
          const hasReturn = this.schedules.some((returnSchedule) => {
            const isValidReturn = returnSchedule && returnSchedule.origin && returnSchedule.destination && returnSchedule.operationDateSummary && returnSchedule.origin.toLowerCase() === this.filters.destination.toLowerCase() && returnSchedule.destination.toLowerCase() === this.filters.origin.toLowerCase() && this.isDateInRange(returnSchedule.operationDateSummary, this.filters.dateRangeStart, this.filters.dateRangeEnd)
            if (isValidReturn) {
              console.log("Found valid return flight:", returnSchedule)
            } else {
              console.log("No valid return flight for:", schedule, "Checked:", returnSchedule)
            }
            return isValidReturn
          })
          if (!hasReturn) {
            console.log("No return flight found for schedule:", schedule)
            this.hasValidReturnFlights = false
          }
          return hasReturn
        }
        return true
      },
      getDayClass(daysOfWeek, day) {
        if (!daysOfWeek || typeof daysOfWeek[day] !== "boolean") {
          console.warn(`Invalid daysOfWeek for ${day}:`, daysOfWeek)
          return "day-circle-false" // 默認紅色圓圈
        }
        return daysOfWeek[day] ? "day-circle-true" : ""
      },
      formatTime(time) {
        if (!time || typeof time !== "string") return "-"
        return time.slice(0, 5) // 提取 HH:mm
      },
    },
    mounted() {
      if (typeof flightData === "undefined" || !flightData) {
        console.error("flightData is not defined or empty. Please check flights.js.")
        this.schedules = []
        return
      }
      if (!flightData.data || !Array.isArray(flightData.data)) {
        console.error("flightData.data is missing or not an array:", flightData)
        this.schedules = []
        return
      }
      try {
        this.schedules = flightData.data
          .flatMap((country) => {
            if (!country || !country.stationSchedules || !Array.isArray(country.stationSchedules)) {
              console.warn("Invalid country data:", country)
              return []
            }
            return country.stationSchedules
          })
          .flatMap((station) => {
            if (!station || !station.schedules || !Array.isArray(station.schedules)) {
              console.warn("Invalid station data:", station)
              return []
            }
            return station.schedules.filter((schedule) => {
              const isValid = schedule && typeof schedule === "object" && schedule.origin && schedule.destination && schedule.carrierCode && schedule.flightNumber && schedule.departureTime && schedule.arrivalTime && schedule.operationDateSummary && schedule.daysOfWeek && typeof schedule.daysOfWeek === "object"
              if (!isValid) console.warn("Invalid schedule in station:", schedule)
              return isValid
            })
          })
        console.log("Loaded schedules:", this.schedules)
        if (this.schedules.length === 0) {
          console.warn("No valid schedules loaded. Check JSON data structure.")
        }
      } catch (error) {
        console.error("Error loading schedules:", error)
        this.schedules = []
      }
    },
  }
</script>
